// 根据环境引入不同配置 process.env.NODE_ENV
import uat_const from './constants_uat';
import prod_const from './constants_prod';
export default process.env.NODE_ENV === 'production' ? prod_const : uat_const;